import Icon from 'src/components/Icon';
/**
 * Local replacements for @rjsf/core/lib/components/IconButton and AddButton,
 * which were removed from the public API in RJSF v5+.
 */

export function IconButton({ icon, type, className = '', children, ...props }) {
  const iconMap = {
    'arrow-up': 'ArrowUp',
    'arrow-down': 'ArrowDown',
    remove: 'phosphor-X',
    plus: 'phosphor-Plus',
  };
  const iconClass = iconMap[icon] || `fa fa-${icon}`;
  const btnVariant = type === 'danger' ? 'btn-danger' : 'btn-default';

  return (
    <button type="button" className={`btn ${btnVariant} ${className}`} {...props}>
      <Icon icon={iconClass} />
      {children}
    </button>
  );
}

export function AddButton({ className = '', children, ...props }) {
  return (
    <button type="button" className={`btn btn-info ${className}`} {...props}>
      <Icon icon="Plus" weight="regular" />
      {children}
    </button>
  );
}
